import Container from '@/components/base/Container';
import Section from '@/components/base/Section';
import Reveal from '@/components/base/Reveal';

export default function PracticeFeature() {
  return (
    <Section labelledBy="practice-heading" divider>
      <Container>
        <div className="grid grid-cols-1 items-center gap-8 md:gap-10 lg:grid-cols-12 lg:gap-x-14">
          <div className="lg:col-span-7">
            <Reveal variant="wipe">
              <div className="aspect-[4/3] w-full overflow-hidden rounded-[12px] bg-background-100 lg:aspect-auto lg:h-[480px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_about-practice.webp"
                  alt="Community manager speaking with a resident outside a residential building"
                  title="Community management in practice - COMMON Property Management"
                  className="h-full w-full object-cover object-center"
                />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={100}>
              <p className="mb-3 font-label text-[12px] font-semibold uppercase tracking-[0.14em] text-accent-500 md:text-[13px]">In practice</p>
            </Reveal>
            <Reveal delay={200}>
              <h2 id="practice-heading" className="font-heading text-[28px] font-semibold leading-[1.15] tracking-[-0.01em] text-[#222222] md:text-[34px] lg:text-[40px]">
                Thoughtful management is mostly consistent, careful follow-through.
              </h2>
            </Reveal>
            <Reveal delay={300}>
              <div className="mt-6 max-w-[480px] space-y-5">
                <p className="text-[16px] leading-[1.65] text-foreground-700">
                  It means returning calls, keeping inspection schedules and knowing the property well enough to notice when something changes. It means giving boards information they can act on, and giving residents answers they can understand.
                </p>
                <p className="border-l-2 border-[#79BC68] pl-4 text-[16px] leading-[1.65] text-[#222222]">
                  None of it is dramatic. Done well and done consistently, it is what makes a community feel looked after.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </Container>
    </Section>
  );
}